(function () {
    'use strict';

    angular
        .module('app')
        .controller('ftsOptions', ftsOptions);

    ftsOptions.$inject = ['ftsOptionsService', '$mdDialog', '$filter', 'loginService', '$rootScope'];
    function ftsOptions(ftsOptionsService, $mdDialog, $filter, loginService, $rootScope) {
        var vm = this;

        vm.ftsOptionsLabel = loginService.resourceStrings["FTS_OPTIONS"]; // "Full Text Options"
        vm.ftsIndexLocationLabel = loginService.resourceStrings["FULL_TEXT_INDEXLOCATION"]; // "Full Text Index Location"
        vm.ftsIndexLocationPlaceholderLabel = loginService.resourceStrings["FULL_TEXT_INDEXLOCATION_PLACEHOLDER"]; // "Full Text Index Location"
        vm.okLabel = loginService.resourceStrings["OK"]; // "OK"
        vm.cancelLabel = loginService.resourceStrings["CANCEL"]; // "Cancel" 
        vm.overwriteMessage = loginService.resourceStrings["FULL_TEXT_OVERWRITE"];
        vm.invalidFolder = loginService.resourceStrings["FULL_TEXT_INVALIDFOLDER"];
        vm.ftsIndexLocationId = "";

        activate();
        vm.ftsOptionsService = ftsOptionsService;

        ftsOptionsService.getFtsIndexLocation().then(function (data) {
            if (data != null)
                vm.ftsIndexLocationId = data;
        });

        // Callback from the input box after the box has closed.
        var ftsValidatePostCloseCallback = function (param1, param2, iChoice) {
            if (iChoice == 2)
                return;

            var bOverwrite = iChoice == 0;
            ftsOptionsService.setFtsIndexLocation(param1, bOverwrite);
            $mdDialog.hide();
        }

        //when the ok button is clicked
        vm.onOk = function () {
            //set the fields
            ftsOptionsService.validateFtsIndexLocation(vm.ftsIndexLocationId).then(function (data) {
                if (data != null) {
                    if (data.bNotFolder) {
                        $rootScope.msgBoxShow(vm.invalidFolder);
                        return;
                    }
                    if (data.bHasFiles) {
                        $rootScope.yesNoCancelBoxShow(vm.ftsIndexLocationId, "", "", vm.overwriteMessage, "", ftsValidatePostCloseCallback);
                        return;
                    }
                    ftsOptionsService.setFtsIndexLocation(vm.ftsIndexLocationId, false);
                    $mdDialog.hide();
                }
            });
        }

        //when the cancel button is clicked
        vm.onCancel = function () {
            $mdDialog.cancel();
        }

        function activate() { }

    }
})();
